import React from "react";
import { Leaf, UtensilsCrossed, Flame, HeartHandshake } from "lucide-react";
const pillars = [{
  title: "Estratégia Criativa",
  description: "Abordagem analítica para transformar conceitos em resultados mensuráveis e impacto real.",
  icon: Leaf
}, {
  title: "Design de Elite",
  description: "Estética refinada que comunica autoridade e sofisticação em cada ponto de contato.",
  icon: UtensilsCrossed
}, {
  title: "Execução Ágil",
  description: "Processos otimizados para entregas de alta performance sem comprometer a qualidade.",
  icon: Flame
}, {
  title: "Parceria Próxima",
  description: "Atendimento consultivo e dedicado para garantir que sua visão seja superada.",
  icon: HeartHandshake
}];
export default function DirectFromTheSource() {
  return <section data-section-id="224118" id="diferenciais" className="bg-background text-foreground">
      <style>{`
        @keyframes breathe-icon {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.1); }
        }
        .animate-breathe {
          animation: breathe-icon 4s ease-in-out infinite;
        }
        .separator-line {
          border-bottom: 1px solid hsl(0, 0%, 95%);
        }
      `}</style>
      
      {}
      <div className="bg-card py-24 w-full">
        <div className="container mx-auto px-6 md:px-12 max-w-[800px]">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
            {pillars.map((pillar, i) => <div key={i} data-index={i} className={`flex flex-col items-center text-center space-y-6 group ${i < pillars.length - 1 ? 'lg:border-r lg:border-[hsl(0,0%,95%)]' : ''}`}>
                <div className="text-primary animate-breathe flex items-center justify-center h-20 w-20">
                  <pillar.icon size={48} strokeWidth={1} className="opacity-100" />
                </div>
                <div className="space-y-3">
                  <h3 className="font-default font-bold text-xl tracking-tight text-foreground">
                    {pillar.title}
                  </h3>
                  <p className="font-default text-muted-foreground text-sm leading-[1.6] max-w-[250px] mx-auto">
                    {pillar.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}